import ApiClient from "@common/api/ApiClient";

class AgcCheckClient extends ApiClient {
  constructor() {
    super("AGCCheck");
    this.setApiUrlKey("comp_api_url");
  }

  Create = async (payload) => await this.post("Create", payload);

  Search = async (payload = { siteId: 0 }) =>
    await this.post("Search", payload);

  Read = async (id) => await this.get(`Read?id=${id}`);

  ReadForUpdate = async (id) => await this.get(`Update?id=${id}`);

  Update = async (payload) => await this.post("Update", payload);
}

const client = new AgcCheckClient();

export default client;
